// @flow
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { withHelmet } from 'infrastructure/seo/Helmet';
import { dynamicClassName } from 'utils/dynamicClassName';
import CardBackground from 'containers/fragments/card/CardBackgroundContainer';
import MatchResult from 'components/fragments/MatchResult';
import BackgroundImage from 'components/fragments/BackgroundImage';
import type { TeamList } from 'types/TeamList';
import type { CardType, YoutubeVideoType } from 'types/PageList';
import type { BlocContent } from 'types/NewsletterBloc';
import type { ArticleType } from 'types/Article';
import type { Status } from 'types/Status';
import type { MatchResultType } from 'types/Match';
import type { FullUserType } from 'types/User';
import { getDateFromString, formatFullDate } from 'utils/dateUtils';
import { STATUS_UNKNOWN, STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';
import { ARTICLE_PER_PAGE } from 'constants/articleConstants';
import CardBoutique from 'containers/fragments/CardBoutiqueContainer';
import JoinStories from 'components/fragments/JoinStories';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import PageNotFound from 'components/app/PageNotFound';
import Loading from 'components/fragments/Loading';
import Breadcrumb from 'components/fragments/Breadcrumb';
import { teamSubmenuHeaders } from 'constants/menuConstants';
import SubMenuHeader from 'components/header/SubMenuHeader';
import FooterTeamArticle from 'components/team/FooterTeamArticle';
import TeamMenuDropdownMenu from 'components/teammenu/TeamMenuDropdownMenu';
// import ParionsSportCote from 'containers/parionsSport/ParionsSportCoteContainer';
//import { parionsSportLink } from 'constants/parionsSportsConstant';
import { youtubeDurationToTime } from 'utils/socialUtils';
import { handleTagEvent } from 'utils/tagManagerUtils';
import { getMetaBySlug } from 'utils/seoUtils';

import { Link } from 'react-router-dom';

import './TeamDetail.css';

export type StateProps = {
  title: string,
  description: BlocContent[],
  excerpt: string,
  label: {
    id: number,
    name: string,
    slug: string
  },
  featured_media: {
    src: string,
    legend: string
  },
  liste_cards: CardType[],
  articles: ArticleType[],
  results_future: MatchResultType[],
  results_past: MatchResultType[],
  youtube_playlist: YoutubeVideoType[],
  titre_youtube: string,
  status: Status,
  teamlist: TeamList[],
  redirection: string,
  redirect_competitions: string,
  redirect_resultats: string,
  userPref: FullUserType
};

export type DispatchProps = {
  fetchPageList: (slug: string) => void,
  fetchMatchsFutureTeam: (start_date: string, team: string, per_page: number) => void,
  fetchMatchsPastTeam: (end_date: string, team: string, per_page: number) => void,
  fetchTeamList: () => void,
  fetchArticlesCategory: (page: number, per_page: number, category: string) => void
};

type Props = {
  match: {
    params: {
      slug: string,
      typeRugby: string
    }
  },
  history: any,
  pageSlug: string
} & DispatchProps &
  StateProps;

type State = {
  currentPage: string,
  timestamp: any
};
class TeamDetail extends Component<Props, State> {
  state: State = {
    currentPage: '',
    timestamp: ''
  };

  componentDidMount() {
    const { slug } = this.props.match.params;
    const { label } = this.props;
    let date = new Date();
    date = date.toISOString().substring(0, 14) + '00:00';
    date = date.replace('T', ' ');
    if (slug) {
      this.props.fetchPageList(slug);
      this.props.fetchMatchsFutureTeam(date, slug, 1);
      this.props.fetchMatchsPastTeam(date, slug, 3);
    } else {
      this.props.fetchPageList(this.props.pageSlug);
      this.props.fetchMatchsFutureTeam(date, this.props.pageSlug, 1);
      this.props.fetchMatchsPastTeam(date, this.props.pageSlug, 3);
    }
    if (label && label.slug && label.slug !== '') {
      this.props.fetchArticlesCategory(1, ARTICLE_PER_PAGE, label.slug);
    }
    this.setState({ currentPage: 'ok' });
    this.props.fetchTeamList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.label.slug !== prevProps.label.slug) {
      this.props.fetchArticlesCategory(1, ARTICLE_PER_PAGE, this.props.label.slug);
    }
  }

  shouldComponentUpdate(nextProps: Props) {
    const { slug } = this.props.match.params;
    if (nextProps !== this.props) {
      if (nextProps.match.params.slug !== slug) {
        if (nextProps.match.params.slug) {
          let date = new Date();
          date = date.toISOString().substring(0, 14) + '00:00';
          date = date.replace('T', ' ');
          this.props.fetchPageList(nextProps.match.params.slug);
          this.props.fetchMatchsFutureTeam(date, nextProps.match.params.slug, 1);
          this.props.fetchMatchsPastTeam(date, nextProps.match.params.slug, 3);
          return true;
        }
      }
      return true;
    }
    return false;
  }

  renderCards = () => {
    const { slug } = this.props.match.params;
    const { liste_cards } = this.props;
    return liste_cards.map((card, index) => {
      const classNameContainer = dynamicClassName('col mb-2 mb-lg-4');
      index === 0 ? classNameContainer.add('col-md-8') : classNameContainer.add('col-md-4');
      if (index < 2) {
        return (
          <div key={index} className={classNameContainer.build()}>
            <CardBackground
              url={index === 0 ? slug + '/joueurs' : slug + '/staff'}
              backgroundUrl={card.featured_media}
              title={card.title}
              desc={card.description}
              linkLabel={card.texte_cta}
            />
          </div>
        );
      } else {
        return false;
      }
    });
  };

  onBilletterieClick = (adversaire: string, reception: number) => {
    const { userPref } = this.props;
    const matchTitle = reception ? `France-${adversaire}` : `${adversaire}-France`;
    return handleTagEvent('billet_match', 'achat_billet', matchTitle, userPref);
  };

  renderNextMatch = () => {
    const {
      match: {
        params: { slug }
      }
    } = this.props;
    const {
      journee,
      link,
      competition,
      meta: { billetterie, date_rencontre, france_logo, adversaire_logo, adversaire, lieu, reception }
    } = this.props.results_future[0];
    let texte_journee = '';

    if (journee) {
      texte_journee = 'Journée ' + journee.toString() + '  —  ';
    }
    return (
      <div className="box box--white card card--nextGameWhite">
        <div className="card__body card__flex-body">
          <h3 className="card__title ft-h3">Prochain match</h3>
          <Link to={link} className="flex1">
            <p className="ft-h6 ft-up">{competition ? competition.name : ''}</p>
            <p className="ft-h6 ft-up mb-3">
              {texte_journee}
              {formatFullDate(getDateFromString(date_rencontre))}
            </p>
            <div className="card__body__teams-block">
              <div>
                <p className="ft-h3 ft-400 mb-2">
                  <img src={france_logo} alt="Logo XV de France" width="40" height="40" />
                  <span>France</span>
                </p>
                <p className="ft-h3 ft-400 mb-2">
                  <img src={adversaire_logo} alt={adversaire} width="40" height="40" />
                  <span>{adversaire}</span>
                </p>
              </div>

              {lieu && (
                <p className="ft-h6 ft-up">
                  <i className="icon icon-place is-inline"> </i>
                  <span>{lieu}</span>
                </p>
              )}

              {/* {this.props.match.params.slug === 'xv-de-france-masculin' && (
                <ParionsSportCote matchDate={new Date(date_rencontre)} classParent={'ft-h6 ft-up'} />
              )} */}
            </div>
          </Link>
          {billetterie && (
            <a
              href={billetterie}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--primary btn--full"
              onClick={this.onBilletterieClick(adversaire, reception)}
            >
              <i className="icon icon-store is-inline"></i>
              <span>Acheter vos billets</span>
            </a>
          )}
        </div>
        <div className="card__footer">
          <Link to={`${slug}/agenda`} className="link-chevron">
            <span>{`Consulter l'agenda`}</span>
            <i className="icon icon-chevron-right"></i>
          </Link>
        </div>
      </div>
    );
  };

  renderNews = () => {
    const { articles, label } = this.props;
    return (
      <div className="box box--white card card--news box--white">
        <div className="card__body">
          <h3 className="ft-h3 mb-2">Dernières actualités</h3>
          {articles &&
            articles.length > 0 &&
            articles.map((article, index) => {
              if (index < 4) {
                return (
                  <a className="news" key={index} href={article.link}>
                    <span className="news__title ft-h5">
                      {article.title}
                      <p className="ft-h6">{formatFullDate(getDateFromString(article.date))}</p>
                    </span>
                  </a>
                );
              }
              return null;
            })}
        </div>
        {label.slug && (
          <div className="card__footer">
            <Link
              to={`/actualites/${label.slug}`}
              title={`Voir plus`}
              className="link-chevron link-chevron--block"
              data-label=""
            >
              <span>{"Consulter plus d'actualités"}</span>
              <i className="icon icon-chevron-right"></i>
            </Link>
          </div>
        )}
      </div>
    );
  };
  renderPastMatch = () => {
    const {
      match: {
        params: { slug }
      }
    } = this.props;
    return (
      <div className="box box--white card card--result">
        <div className="card__body card__flex-body">
          <h3 className="mb-2">Derniers résultats</h3>
          {this.renderPastMatchList()}
        </div>
        <div className="card__footer">
          <Link to={`${slug}/resultats`} className="link-chevron link-chevron--block">
            <span>{`Voir tous les résultats de l'équipe`}</span>
            <i className="icon icon-chevron-right"></i>
          </Link>
        </div>
      </div>
    );
  };

  renderPastMatchList = () => {
    const { results_past } = this.props;
    let competition = false;
    let lastPastResults = results_past;
    let filteredCompetitions = [];

    //* we want to know how many competitions the last three games belong to
    // so we need to delete the duplicate from the
    filteredCompetitions = lastPastResults.reduce((filteredCompetitions, result) => {
      // for each result, keep the competition if it's not already in filteredCompetitions
      if (!filteredCompetitions.includes(result.competition.id)) {
        return filteredCompetitions.concat(result.competition.id);
      }

      // otherwise, keep filteredCompetitions as it is since the competition is already in it
      return filteredCompetitions;
    }, []);

    //* if we have 3 competitions, we don't want to display the last one
    if (filteredCompetitions && filteredCompetitions.length > 2) {
      // https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Array/slice
      lastPastResults = lastPastResults.slice(0, 2);
    }

    //* display the cards
    return lastPastResults.map((card, index) => {
      let newcompetition = false;

      if (card.competition.name !== competition) {
        competition = card.competition.name;
        newcompetition = true;
      }

      return (
        <div key={index}>
          {newcompetition && index > 0 && <hr style={{ marginTop: 0, marginBottom: '10px' }} />}
          <MatchResult
            url={card.link}
            adversaire={card.meta.adversaire}
            reception={card.meta.reception}
            score_france={card.meta.france_score}
            score_adversaire={card.meta.adversaire_score}
            logo_france={card.meta.france_logo}
            logo_adversaire={card.meta.adversaire_logo}
            date_rencontre={formatFullDate(getDateFromString(card.meta.date_rencontre))}
            journee={card.meta.journee}
            competition={newcompetition === true ? card.competition : {}}
          />
        </div>
      );
    });
  };
  renderBoutique = () => {
    return <CardBoutique />;
  };

  teamChange(team: Object) {
    this.props.history.push(team.link);
  }

  render() {
    const {
      title,
      featured_media,
      description,
      excerpt,
      label,
      status,
      results_future,
      results_past,
      articles,
      youtube_playlist,
      titre_youtube,
      teamlist,
      redirection,
      redirect_competitions,
      redirect_resultats
    } = this.props;

    let selectedTeam = false;
    if (teamlist && teamlist.length > 0) {
      selectedTeam = teamlist.filter((team, index) => {
        return team.title === title;
      });
    }

    const { typeRugby, slug } = this.props.match.params;
    if (status === STATUS_LOADING) {
      return <Loading isBlue backgroundColor={'#013974'} />;
    }

    if (status === STATUS_UNKNOWN) {
      return <PageNotFound />;
    }

    if (this.state.currentPage === 'ok' && status === STATUS_SUCCESS && redirection) {
      return <Redirect to={{ pathname: redirection, state: { redirection: false } }} />;
    }

    if (redirect_competitions && redirect_competitions !== '') {
      teamSubmenuHeaders[3].type_name = 'external';
      teamSubmenuHeaders[3].object_slug = redirect_competitions;
    } else {
      teamSubmenuHeaders[3].type_name = 'endur';
      teamSubmenuHeaders[3].object_slug = 'competitions';
    }

    if (redirect_resultats && redirect_competitions !== '') {
      teamSubmenuHeaders[2].type_name = 'external';
      teamSubmenuHeaders[2].object_slug = redirect_resultats;
    } else {
      teamSubmenuHeaders[2].type_name = 'endur';
      teamSubmenuHeaders[2].object_slug = 'resultats';
    }

    if (this.props.match.params.slug === 'xv-de-france') {
      teamSubmenuHeaders[7] = {
        menu_order: 35,
        object_slug: '/le-grand-soutien',
        title: 'Le grand soutien',
        description: '',
        featured_media: { src: '' },
        texte_cta: '',
        object_id: 0,
        type_name: 'external'
      };
    }

    /*if (this.props.match.params.slug === 'xv-de-france-masculin') {
      teamSubmenuHeaders[7] = {
        menu_order: 40,
        object_slug: parionsSportLink,
        title: 'Parions Sport',
        description: '',
        featured_media: { src: '' },
        texte_cta: '',
        object_id: 0,
        type_name: 'external'
      };
    }*/
    if (teamSubmenuHeaders[7] && teamSubmenuHeaders[7].title === 'Parions Sport') {
      delete teamSubmenuHeaders[7];
    }

    /**
     * Si pas de matchs à venir et plus de deux blocs disponibles,
     * on commence à compter à partir du second bloc présent,
     * le premier est théoriquement utilisé sur la home comme bandeau pour remplacer le lien
     * vers le prochain match
     */
    let count = (!results_future || !results_future[0]) && description.length > 2 ? 1 : 0;
    let bloc_results_past = false;
    let bloc_results_future = false;
    let data_joueur_mois = false;
    if (!results_past || !results_past[0]) {
      if (description && description[count]) {
        bloc_results_past = description[count];
        count++;
      }
    }
    if (!results_future || !results_future[0]) {
      if (description && description[count]) {
        bloc_results_future = description[count];
      } else if (selectedTeam && selectedTeam.length > 0 && selectedTeam[0].joueur_du_mois) {
        data_joueur_mois = selectedTeam[0].joueur_du_mois;
      }
    }
    // console.log('teamSubmenuHeaders', teamSubmenuHeaders);
    return (
      <>
        <section className="banner">
          <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: `url(${featured_media.src})` }} />
          <div className="container">
            <Breadcrumb
              elements={[
                { name: 'accueil', to: '/' },
                { name: 'Équipes de France', to: '/equipe-de-france' },
                { name: typeRugby.replace(/-/g, ' '), to: '/equipe-de-france/' + typeRugby },
                title
              ]}
              isDark
            />
            {teamlist && teamlist.length > 0 && selectedTeam && selectedTeam.length > 0 && (
              <TeamMenuDropdownMenu
                hiddenMenuElements={teamlist}
                isMobile={false}
                id={6}
                level={'h1'}
                activeTeam={selectedTeam[0]}
                switchTeam={this.teamChange.bind(this)}
              />
            )}
            {(!teamlist || teamlist.length === 0) && <h1 className="ft-h2">{title}</h1>}
            {excerpt && <p className="banner__desc">{excerpt}</p>}
          </div>
          <SubMenuHeader
            subMenus={teamSubmenuHeaders}
            subMenuPath={'/equipe-de-france/' + typeRugby + '/' + slug}
            status={STATUS_SUCCESS}
            niveauMenu={4}
          />
        </section>

        <div className="container section section--team">
          <div className="row">{this.renderCards()}</div>
          <div className="row three-block-row">
            <div className="col col-lg-4 mb-2 mb-lg-4">
              {results_past && results_past[0] && this.renderPastMatch()}
              {(!results_past || !results_past[0]) && bloc_results_past && <ContentBloc {...bloc_results_past} />}
            </div>

            <div className="col col-lg-4 mb-2 mb-lg-4">
              {results_future && results_future[0] && this.renderNextMatch()}
              {(!results_future || !results_future[0]) && bloc_results_future && (
                <ContentBloc {...bloc_results_future} />
              )}
              {(!results_future || !results_future[0]) && data_joueur_mois && (
                <a href={data_joueur_mois.link} className="box card card--picture box--white">
                  <BackgroundImage
                    className="card__thumbnail img-blue"
                    illustration={data_joueur_mois.featured_image}
                    srcset={data_joueur_mois.srcset}
                  />
                  <div className="card__body">
                    <h3 className="card__title">{data_joueur_mois.nom}</h3>
                    <p className="card__desc ft-h6 ft-up ft-truncat">Joueur du mois</p>
                  </div>
                  <div className="card__footer">
                    <span className="link-chevron">
                      Découvrir son profil<i className="icon icon-chevron-right"></i>
                    </span>
                  </div>
                </a>
              )}
            </div>

            <div className="col col-lg-4 mb-2">{articles && articles[0] && this.renderNews()}</div>
          </div>
          <div className="row">{this.renderBoutique()}</div>
        </div>

        {this.props.match.params.slug === 'xv-de-france-masculin' && (
          <section className="section section--white section--join-stories">
            <div className="container">
              <h3 className="ft-h2 mb-2">Destin mêlés</h3>
              <JoinStories
                styles={{
                  '--join-widget-card-mobile-height': '325px',
                  '--join-widget-card-desktop-height': '400px',
                  margin: '5px 2px',
                  minHeight: 'calc(var(--join-widget-card-mobile-height) + 30px)'
                }} // à voir !!!
                scriptSrc="https://ffr.my.join-stories.com/widgets/destins-meles/index.js"
                scriptWidgetId="list-card-destins-meles"
                scriptWidgetAlias="destins-meles"
              />{' '}
              <JoinStories
                styles={{
                  '--join-widget-bubble-mobile-height': '75px',
                  '--join-widget-bubble-desktop-height': '89px',
                  margin: '5px 2px',
                  minHeight: 'calc(var(--join-widget-bubble-mobile-height) + 39px)'
                }} // à voir !!!
                scriptSrc="https://ffr.my.join-stories.com/widgets/destins-meles-mobile/index.js"
                scriptWidgetId="list-bubble-destins-meles-mobile"
                scriptWidgetAlias="destins-meles-mobile"
              />
            </div>
          </section>
        )}

        {label.name && <FooterTeamArticle articles={articles} slug={label.slug} label={label.name} />}

        {youtube_playlist && youtube_playlist.length > 0 && (
          <section className="section section-blueAlt">
            <div className="container">
              <Link to="/ffr-tv" className="link-chevron link-chevron--right section__link mt-1">
                <span>Accéder à la FFR TV</span>
                <i className="icon icon-chevron-right"></i>
              </Link>
              <h3 className="ft-h2 mb-3 mb-lg-4">{titre_youtube ? titre_youtube : 'En vidéos'}</h3>
              <div className="news-slider">
                <div className="news-slider__wrapper news-slider__wrapper--video">
                  {youtube_playlist.map((c, index: number) => {
                    if (index < 3) {
                      return (
                        <Link
                          key={index}
                          to={`/ffr-tv-player/${c.id}`}
                          className="box card card--video"
                          title="Voir cette vidéo sur Youtube"
                          rel="noreferrer noopener"
                        >
                          {c.snippet.thumbnails && (c.snippet.thumbnails.standard || c.snippet.thumbnails.high) && (
                            <div
                              className="card__thumbnail img-blue-dark"
                              style={{
                                backgroundImage: `url(${
                                  c.snippet.thumbnails.standard
                                    ? c.snippet.thumbnails.standard.url
                                    : c.snippet.thumbnails.high.url
                                })`
                              }}
                            >
                              <img
                                src={
                                  c.snippet.thumbnails.standard
                                    ? c.snippet.thumbnails.standard.url
                                    : c.snippet.thumbnails.high.url
                                }
                                alt=""
                              />
                            </div>
                          )}
                          <div className="card__footer">
                            <span className="link-icon link-icon--medium is-dark">
                              <i className="icon icon-play"></i>
                            </span>
                            <h5
                              className="card__title ft-truncat"
                              dangerouslySetInnerHTML={{ __html: c.snippet.description }}
                            />
                            <p className="card__date">{youtubeDurationToTime(c.contentDetails.duration)}</p>
                          </div>
                          <div className="card__type">
                            <span className="label label--red">{c.snippet.tags && c.snippet.tags[0]}</span>
                          </div>
                        </Link>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>
              <Link to="/ffr-tv" className="link-chevron link-chevron--right section__link mt-1">
                <span>Accéder à la FFR TV</span>
                <i className="icon icon-chevron-right"></i>
              </Link>
            </div>
          </section>
        )}
      </>
    );
  }
}

export default withHelmet(TeamDetail)((Helmet, pageProps) => {
  const {
    match: { params, url },
    meta_title
  } = pageProps;
  const ogimage = pageProps.featured_media.src;
  const ogimagetitle = pageProps.featured_media.title;
  const meta = getMetaBySlug(url, params);

  return (
    <Helmet>
      <title>{meta.title(meta_title)}</title>
      <meta name={'description'} content={meta.description(meta_title)} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={meta.title(meta_title)} />
      <meta property={'og:description'} content={meta.description(meta_title)} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {ogimage && <meta property={'og:image:url'} content={ogimage} />}
      {ogimage && ogimagetitle && <meta property={'og:image:title'} content={ogimagetitle} />}
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
